// extracted by mini-css-extract-plugin
export default {"messageTypeAlert":"ikCdgiFxOZaNhDtiQe8t"};